import { ButtonSize } from '@farmasiet/frontendcore-reactcomponents';
import * as React from 'react';

import { getTranslation, keys } from '../../../Resources/Translations';
import { NavigationTrackerButtonLink } from '../../ReactComponents/NavigationTracker/NavigationTrackerButtonLink';

interface HeaderButtonsProps {
    readonly rxLandingPageUrl: string;
    readonly chatWithPharmacistLandingPageUrl: string;
}

export const HeaderButtons = ({ rxLandingPageUrl, chatWithPharmacistLandingPageUrl }: HeaderButtonsProps) => {
    return (
        <div className="Header__Buttons">
            <ul className="Header__ButtonsList">
                <li>
                    <NavigationTrackerButtonLink size={ButtonSize.Large} href={rxLandingPageUrl} className="Header__ShopPrescription" source="HeaderButton">
                        {getTranslation(keys['navigation.buyPrescription'])}
                    </NavigationTrackerButtonLink>
                </li>
                <li>
                    <NavigationTrackerButtonLink
                        size={ButtonSize.Large}
                        href={chatWithPharmacistLandingPageUrl}
                        className="Header__ChatWithPharmacist"
                        source="HeaderButton"
                    >
                        {getTranslation(keys['navigation.chatWithPharmacist'])}
                    </NavigationTrackerButtonLink>
                </li>
            </ul>
        </div>
    );
};
